import IdentifyEstate from './NewEstate/IdentifyEstate'
import ChooseSegment from './NewEstate/ChooseSegment'
import EstateInformation from './NewEstate/EstateInformation'

import ChooseBundle from './ProductSelection/ChooseBundle'
import ChooseProducts from './ProductSelection/ChooseProducts'
import Information from './ProductSelection/Information'
import Booking from './ProductSelection/Booking'
import Summary from './ProductSelection/Summary'

export function recursivelySetNextStep(list, steps, step = steps[0]) {
  list.push(step)
  if (step.nextStep) {
    recursivelySetNextStep(list, steps, steps.find(s => s.step === step.nextStep()))
  }
}

export function getOrderingSteps({webOrder, productSelection, estate}) {
  const estatePath = `/bestilling/ny/${webOrder ? webOrder.id : ''}`
  const orderPath = webOrder ? `/bestilling/${webOrder.id}` : null
  const orderWasFromIntegration = webOrder && !!webOrder.thirdPartyApplicationName
  const estateHasSegment = estate && estate.segment && !!estate.segment.id

  const steps = [
    // New estate steps
    {
      scope: 'estate',
      step: 'identifiser-eiendom',
      path: estatePath,
      name: 'Finn adresse',
      Component: IdentifyEstate,
      nextStep: () =>
        orderWasFromIntegration && estateHasSegment
          ? 'oppdragsinformasjon'
          : 'velg-segment',
      canRenderStep: () => true,
    },
    {
      scope: 'estate',
      step: 'velg-segment',
      path: estatePath,
      name: 'Type objekt',
      Component: ChooseSegment,
      nextStep: () => 'oppdragsinformasjon',
      previousStep: () => 'identifiser-eiendom',
      canRenderStep: () => estate && estate.address && estate.address.street, // this feels risky...
    },
    {
      scope: 'estate',
      step: 'oppdragsinformasjon',
      path: estatePath,
      name: 'Objektinformasjon',
      Component: EstateInformation,
      previousStep: () =>
        orderWasFromIntegration && estateHasSegment
          ? 'identifser-eiendom'
          : 'velg-segment',
      canRenderStep: () => estateHasSegment,
    },

    // Product selection steps
    {
      scope: 'order',
      step: 'pakker',
      path: orderPath,
      name: 'Velg pakke',
      Component: ChooseBundle,
      nextStep: () => 'produkter',
      canRenderStep: () => true,
    },
    {
      scope: 'order',
      step: 'produkter',
      path: orderPath,
      name: 'Tilleggsprodukter',
      Component: ChooseProducts,
      nextStep: () => 'informasjon',
      previousStep: () => 'pakker',
      canRenderStep: () => true,
    },
    {
      scope: 'order',
      step: 'informasjon',
      path: orderPath,
      name: 'Oppdragsinformasjon',
      Component: Information,
      nextStep: () => 'booking',
      previousStep: () => 'produkter',
      canRenderStep: () => true,
    },
    {
      scope: 'order',
      step: 'booking',
      path: orderPath,
      name: 'Booking',
      Component: Booking,
      nextStep: () => 'oppsummering',
      previousStep: () => 'informasjon',
      canRenderStep: () => true,
    },
    {
      scope: 'order',
      step: 'oppsummering',
      path: orderPath,
      name: 'Send bestilling',
      Component: Summary,
      previousStep: () => 'booking',
      canRenderStep: () => true,
    },
  ]

  return steps
}
